import { writable, type Readable } from 'svelte/store'

export type ToastLevel = 'info' | 'success' | 'warning' | 'error'

export interface Toast {
  id: number
  message: string
  level: ToastLevel
}

export interface UseToast {
  toasts: Readable<Toast[]>
  show: (message: string, level?: ToastLevel, durationMs?: number) => number
  dismiss: (id: number) => void
  clear: () => void
}

const toasts = writable<Toast[]>([])
let nextId = 1
const DEFAULT_DURATION_MS = 4000

function dismiss(id: number): void {
  toasts.update((list) => list.filter((t) => t.id !== id))
}

function show(
  message: string,
  level: ToastLevel = 'info',
  durationMs: number = DEFAULT_DURATION_MS,
): number {
  const id = nextId++
  toasts.update((list) => [...list, { id, message, level }])
  if (durationMs > 0) {
    setTimeout(() => dismiss(id), durationMs)
  }
  return id
}

function clear(): void {
  toasts.set([])
}

export function useToast(): UseToast {
  return {
    toasts: { subscribe: toasts.subscribe },
    show,
    dismiss,
    clear,
  }
}
